<swiper-container #swiper class="swiper-container" appSwiper [config]="config" init="true">
    <swiper-slide class="swiper-slide" *ngFor="let slide of slides">
        <span #itens></span>
    </swiper-slide>
</swiper-container>